import { Endpoint } from '../endpoint';
import { FolderId, FolderResponse, FolderStructureResponse, SearchResult } from '@business/entities/common/FolderResponse';

/**
 * Fetch folders with optional parent filtering
 */
export function fetchFolders(objectType: string, parentId?: FolderId) {
  return Endpoint.get<FolderResponse[]>(`@gc/folders`, {
    params: {
      parentId: parentId || '0',
      objectType,
    },
  });
}

/**
 * Fetch a specific folder by ID
 */
export function fetchFolder(id: FolderId) {
  return Endpoint.get<FolderResponse>(`@gc/folders/folder/${id}`);
}

/**
 * Create a new folder
 */
export function createFolder(data: Partial<FolderResponse> & { objectType: string }) {
  return Endpoint.post<FolderResponse>(`@gc/folders`, {
    data,
  });
}

/**
 * Update an existing folder
 */
export function updateFolder(id: FolderId, data: Partial<FolderResponse>) {
  return Endpoint.patch<FolderResponse>(`@gc/folders/${id}`, { data });
}

/**
 * Delete a folder
 */
export function deleteFolder(id: FolderId, moveToParent: boolean = false) {
  return Endpoint.delete<{ success: boolean }>(`@gc/folders/${id}`, {
    params: { moveToParent: moveToParent ? '1' : '0' },
  });
}

/**
 * Get folder structure for organizing
 */
export function folderStructure(objectType: string, folderId?: FolderId) {
  return Endpoint.get<FolderStructureResponse>(`@gc/folders/folder-structure`, {
    params: {
      folderId: folderId || '',
      objectType,
    },
  });
}

/**
 * Get breadcrumbs for a folder
 */
export function getBreadcrumbs(id: FolderId) {
  return Endpoint.get<{ breadcrumbs: { id: string; name: string; object_type: string }[] }>(`@gc/folders/${id}/breadcrumbs`);
}

/**
 * Move an item to a different folder
 */
export function moveItem(data: { itemId: string; objectType: string; toFolderId: string }) {
  return Endpoint.post<{ success: boolean; message: string }>(`@gc/folders/move-item`, { data });
}

/**
 * Move a folder to a different parent
 */
export function moveFolder(data: { folderId: string; toParentId: string }) {
  return Endpoint.post<{ success: boolean; message: string }>(`@gc/folders/move-folder`, { data });
}

/**
 * Search items and folders
 */
export function searchItems(query: string, objectType: string) {
  return Endpoint.get<SearchResult[]>(`@gc/folders/search`, {
    params: {
      query,
      objectType,
    },
  });
}
